import * as requestFromServer from "./HomeworkSourcesCrud";
import { callTypes, homeworkSourceSlice } from "./HomeworkSourcesSlice";

const {actions} = homeworkSourceSlice;

export const getHomeworkSources = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getHomeworkSources(queryParams)
    .then(response => {
      dispatch(actions.homeworkSourcesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllHomeworkSources = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllHomeworkSources(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getCourses = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getCourses()
    .then(response => {
      dispatch(actions.coursesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getCoursesForTemplate = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getCourses()
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getGradeCourses = grade => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getGradeCourses(grade)
    .then(response => {
      dispatch(actions.coursesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getHomeworkSource = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewHomeworkSource()
    .then(response => {
      dispatch(actions.homeworkSourceFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getHomeworkSource(id)
    .then(response => {
      dispatch(actions.homeworkSourceFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveHomeworkSource = source => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveHomeworkSource(source)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const saveHomeworkSources = sources => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveHomeworkSources(sources)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const deleteHomeworkSources = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteHomeworkSources(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanCourses = () => dispatch => {
  dispatch(actions.coursesCleaned());
}

export const cleanHomeworkSourcesState = () => dispatch => {
  dispatch(actions.homeworkSourcesStateCleaned());
}